module.exports = __webpack_public_path__ + "img/ic_de.c2748676.svg";